<template>
  <div id="page-user-list">
    <div id="contextMenu" class="context-menu" style="display:none; position:absolute; z-index:1000;">
      <ul>
        <li @click="filterByValue('NOTFROMBOTTOM')">Filter By {{ currentValue }}</li>
        <li @click="filterClear">Clear</li>
      </ul>
    </div>
    <div id="contextMenuProd" class="context-menu" style="display:none; position:absolute; z-index:1000;">
      <ul>
        <li @click="filterByValueProd('NOTFROMBOTTOM')">Filter By {{ currentValue }}</li>
        <li @click="filterClear">Clear</li>
      </ul>
    </div>

    <div class="flex flex-wrap-reverse items-center data-list-btn-container">
      <div
        class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
        @click="refreshMat()">
        <feather-icon icon="RefreshCcwIcon" svgClasses="h-4 w-4" />
        <span class="ml-2 text-base text-primary">Refresh</span>
      </div>
    </div>
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div class="
                p-4
                border border-solid
                d-theme-border-grey-light
                rounded-full
                d-theme-dark-bg
                cursor-pointer
                flex
                items-center
                justify-between
                font-medium
              ">
              <span class="mr-2">{{
                currentPage * paginationPageSize - (paginationPageSize - 1)
              }}
                -
                {{
                  operationsData.length - currentPage * paginationPageSize > 0
                    ? currentPage * paginationPageSize
                    : operationsData.length
                }}
                of {{ operationsData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(100)">
                <span>100</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(500)">
                <span>500</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <vs-input class="
            sm:mr-4
            mr-0
            sm:w-auto
            w-full
            sm:order-normal
            order-3
            sm:mt-0
            mt-4
          " v-model="searchQuery" @input="updateSearchQuery" placeholder="Search..." />
        <vs-button v-if="displayExport != false" class="mb-4 md:mb-0 mr-2" @click="gridApi.exportDataAsCsv()">Export as
          CSV</vs-button>
        <div v-if="hasActiveFilters" class="flex items-center mr-2 mb-4 md:mb-0">
          <span class="text-sm font-medium" style="color: #7367f0;">
            <feather-icon icon="Filter" svgClasses="h-4 w-4 inline mr-1" />
            Filters active
          </span>
        </div>
        <vs-button type="border" color="primary" class="mb-4 md:mb-0" @click="clearAllFilters" icon-pack="feather" icon="icon-x">
          Clear Filters
        </vs-button>
        <!--<vs-button
          class="mb-4 md:mb-0 ml-8"
          color="warning"
          type="border"
          @click="getProductSortedByProjected()"
          >Sort by Projected (UoM)</vs-button
        >-->
        <vs-button class="mb-4 md:mb-0 ml-8" color="warning" type="border" @click="getProductSortedByProjectedVolume();
        removeFilter();
        ">Sort by Projected (m3)</vs-button>
        <vs-button class="mb-4 md:mb-0 ml-4" color="warning" type="border" @click="
          getProductSortedByName();
        removeFilter();
        ">Sort by Name</vs-button><!--<vs-button class="mb-4 md:mb-0 ml-4" color="warning" type="border" @click="
  getProductSortedByPopularity();
removeFilter();
">Sort by Popularity</vs-button>-->
        <vs-button style="float: right" class="mb-4 md:mb-0 ml-4" @click=" removeFilter()">Disable Filter</vs-button>
      </div>
      <!-- AgGrid Table -->
      <ag-grid-vue id="alldatafromaggrid" ref="agGridTable" :components="components" :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table" :columnDefs="columnDefs" :defaultColDef="defaultColDef"
        :rowData="operationsData" colResizeDefault="shift" :animateRows="true" :floatingFilter="true" :pagination="true"
        :paginationPageSize="paginationPageSize" :suppressPaginationPanel="true" @cell-context-menu="onCellContextMenu"
        @grid-ready="onGridReady">
      </ag-grid-vue>

      <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
    </div>




    <div class="vx-row">
      <div class="vx-col lg:w-full w-full">
        <vx-card title="History by Product Categories (m3)" class="mb-8 mt-8">
          <div slot="no-body" class="mt-4">
            <vs-button v-if="displayExport != false" style="float: right" class="mr-8 mb-4"
              @click=" copyToClipboard('select_txt')">Copy To Clipboard</vs-button>
            <vs-button v-if="displayExport != false" @click="openValuationModal()" color="warning" type="border"
              style="float: right" class="mr-8 mb-4">Valuations</vs-button>
            <vs-table id="select_txt" stripe :data="categoryData">
              <template slot="thead">
                <vs-th>PRODUCT CATEGORIES</vs-th>
                <vs-th style="text-align: right">{{ currentMonthMoins6 }}</vs-th>
                <vs-th style="text-align: right">{{ currentMonthMoins5 }}</vs-th>
                <vs-th style="text-align: right">{{ currentMonthMoins4 }}</vs-th>
                <vs-th style="text-align: right">{{ currentMonthMoins3 }}</vs-th>
                <vs-th style="text-align: right">{{ currentMonthMoins2 }}</vs-th>
                <vs-th style="text-align: right">{{ currentMonthMoins1 }}</vs-th>
                <vs-th style="text-align: right">TODAY</vs-th>
                <vs-th style="text-align: right">UoM</vs-th>
                <vs-th style="text-align: right">Valuation (EUR/m3)</vs-th>
                <vs-th style="text-align: right">Valuation (EUR)</vs-th>
                <vs-th style="text-align: right">Actions</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td>
                    <span>
                      #{{ data[indextr].id }}.<b>
                        {{ data[indextr].category }}</b>&nbsp;
                      <span v-if="data[indextr].id == 29">{{ data[indextr].prod }}</span>
                    </span>
                  </vs-td>
                  <vs-td style="text-align: right">
                    <span v-if="parseFloat(data[indextr].gsp6) >= 0">
                      {{ data[indextr].gsp6 }}
                    </span>
                    <span v-else-if="parseFloat(data[indextr].gsp6) < 0" style="color: red">
                      {{ data[indextr].gsp6 }}
                    </span>
                    <span v-else> 0.00 </span>
                  </vs-td>

                  <vs-td style="text-align: right">
                    <span v-if="parseFloat(data[indextr].gsp5) >= 0">
                      {{ data[indextr].gsp5 }}
                    </span>
                    <span v-else-if="parseFloat(data[indextr].gsp5) < 0" style="color: red">
                      {{ data[indextr].gsp5 }}
                    </span>
                    <span v-else> 0.00 </span>
                  </vs-td>

                  <vs-td style="text-align: right">
                    <span v-if="parseFloat(data[indextr].gsp4) >= 0">
                      {{ data[indextr].gsp4 }}
                    </span>
                    <span v-else-if="parseFloat(data[indextr].gsp4) < 0" style="color: red">
                      {{ data[indextr].gsp4 }}
                    </span>
                    <span v-else> 0.00 </span>
                  </vs-td>

                  <vs-td style="text-align: right">
                    <span v-if="parseFloat(data[indextr].gsp3) >= 0">
                      {{ data[indextr].gsp3 }}
                    </span>
                    <span v-else-if="parseFloat(data[indextr].gsp3) < 0" style="color: red">
                      {{ data[indextr].gsp3 }}
                    </span>
                    <span v-else> 0.00 </span>
                  </vs-td>

                  <vs-td style="text-align: right">
                    <span v-if="parseFloat(data[indextr].gsp2) >= 0">
                      {{ data[indextr].gsp2 }}
                    </span>
                    <span v-else-if="parseFloat(data[indextr].gsp2) < 0" style="color: red">
                      {{ data[indextr].gsp2 }}
                    </span>
                    <span v-else> 0.00 </span>
                  </vs-td>

                  <vs-td style="text-align: right">
                    <span v-if="parseFloat(data[indextr].gsp1) >= 0">
                      {{ data[indextr].gsp1 }}
                    </span>
                    <span v-else-if="parseFloat(data[indextr].gsp1) < 0" style="color: red">
                      {{ data[indextr].gsp1 }}
                    </span>
                    <span v-else> 0.00 </span>
                  </vs-td>

                  <vs-td style="text-align: right">
                    <span v-if="parseFloat(data[indextr].gsp0) >= 0">
                      {{ data[indextr].gsp0 }}
                    </span>
                    <span v-else-if="parseFloat(data[indextr].gsp0) < 0" style="color: red">
                      {{ data[indextr].gsp0 }}
                    </span>
                    <span v-else> 0.00 </span>
                  </vs-td>

                  <vs-td>
                    <span v-if="data[indextr].category == 'Anti split plate'">
                      Pcs</span>
                    <span v-else> m3</span>
                  </vs-td>

                  <vs-td style="text-align: right">
                    <span v-if="data[indextr].valuation">
                      {{ data[indextr].valuation }}</span>
                    <span v-else> - </span>
                  </vs-td>
                  <vs-td style="text-align: right">
                    <span v-if="data[indextr].valuation && parseFloat(data[indextr].gsp0) >= 0">
                      {{ (data[indextr].gsp0 * data[indextr].valuation).toFixed(2) }}
                    </span>
                    <span v-else> - </span>
                  </vs-td>
                  <vs-td>
                    <feather-icon icon="FilterIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="
                      filterByValue('#' +
                        data[indextr].id + '. ' + data[indextr].category
                      )
                      " />
                  </vs-td>
                </vs-tr>
                <!-- Totals Row -->
                <vs-tr class="font-bold bg-gray-100">
                  <vs-td>
                    <span>TOTAL</span>
                  </vs-td>
                  <vs-td style="text-align: right">
                    <span :style="{ color: categoryTotals.gsp6 < 0 ? 'red' : 'inherit' }">
                      {{ categoryTotals.gsp6.toFixed(2) }}
                    </span>
                  </vs-td>
                  <vs-td style="text-align: right">
                    <span :style="{ color: categoryTotals.gsp5 < 0 ? 'red' : 'inherit' }">
                      {{ categoryTotals.gsp5.toFixed(2) }}
                    </span>
                  </vs-td>
                  <vs-td style="text-align: right">
                    <span :style="{ color: categoryTotals.gsp4 < 0 ? 'red' : 'inherit' }">
                      {{ categoryTotals.gsp4.toFixed(2) }}
                    </span>
                  </vs-td>
                  <vs-td style="text-align: right">
                    <span :style="{ color: categoryTotals.gsp3 < 0 ? 'red' : 'inherit' }">
                      {{ categoryTotals.gsp3.toFixed(2) }}
                    </span>
                  </vs-td>
                  <vs-td style="text-align: right">
                    <span :style="{ color: categoryTotals.gsp2 < 0 ? 'red' : 'inherit' }">
                      {{ categoryTotals.gsp2.toFixed(2) }}
                    </span>
                  </vs-td>
                  <vs-td style="text-align: right">
                    <span :style="{ color: categoryTotals.gsp1 < 0 ? 'red' : 'inherit' }">
                      {{ categoryTotals.gsp1.toFixed(2) }}
                    </span>
                  </vs-td>
                  <vs-td style="text-align: right">
                    <span :style="{ color: categoryTotals.gsp0 < 0 ? 'red' : 'inherit' }">
                      {{ categoryTotals.gsp0.toFixed(2) }}
                    </span>
                  </vs-td>

                  <vs-td>
                    <span>m3</span>
                  </vs-td>
                  <vs-td style="text-align: left">
                    -
                  </vs-td>
                  <vs-td style="text-align: right">
                    {{ categoryTotals.totalValuation.toFixed(2) }}
                  </vs-td>
                  <vs-td style="text-align: right">

                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </vx-card>
      </div>
    </div>



    <vs-popup :title="'Valuation Table'" :active.sync="showValuationModal" class="w-full">
      <vs-table :data="categoryDataWithEditableValuations" stripe>
        <template slot="thead">
          <vs-th>Catégorie</vs-th>
          <vs-th>Valeur</vs-th>
          <vs-th>Actions</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr v-for="(item, i) in data" :key="i">
            <vs-td><b>#{{ item.id }}. {{ item.category }}</b> <span v-if="item.id == 29">{{ item.prod }} ({{ item.idid
            }})</span></vs-td>
            <vs-td>
              <vs-input v-model="item.valuation_value" type="number" class="w-32" />
            </vs-td>
            <vs-td>
              <vs-button size="small" color="success" @click="saveOneValuation(item)">SAVE</vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-popup>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import VueApexCharts from "vue-apexcharts";
const themeColors = ["#28C76F", "#EA5455", "#EA5455", "#FF9F43", "#1E1E1E"];
import moment from "moment";
import axios from "@/axios.js";

// Store Module
import moduleStockList from "@/store/stock/moduleOperationList.js";

// Cell Renderer
import CellRendererLink from "./cell-renderer/CellRendererLink.vue";
//import CellRendererPopularity from "./cell-renderer/CellRendererPopularity.vue";
import CellRendererStatus from "./cell-renderer/CellRendererStatus.vue";
import CellRendererVerified from "./cell-renderer/CellRendererVerified.vue";
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";

export default {
  components: {
    VueApexCharts,
    AgGridVue,
    vSelect,

    // Cell Renderer
    CellRendererLink,
    CellRendererStatus,
    //CellRendererPopularity,
    CellRendererVerified,
    CellRendererActions,
  },
  data() {
    return {
      showValuationModal: false,
      valuationList: [],
      categoryDataWithEditableValuations: [],
      currentValue: null,
      alreadyajusted: false,
      maxPopularity: 0,
      currentMonth: "Today",
      currentMonthMoins1: moment(moment(), "MM-YYYY")
        .subtract(1, "months")
        .format("MMMM YY")
        .toUpperCase(),
      currentMonthMoins2: moment(moment(), "MM-YYYY")
        .subtract(2, "months")
        .format("MMMM YY")
        .toUpperCase(),
      currentMonthMoins3: moment(moment(), "MM-YYYY")
        .subtract(3, "months")
        .format("MMMM YY")
        .toUpperCase(),
      currentMonthMoins4: moment(moment(), "MM-YYYY")
        .subtract(4, "months")
        .format("MMMM YY")
        .toUpperCase(),
      currentMonthMoins5: moment(moment(), "MM-YYYY")
        .subtract(5, "months")
        .format("MMMM YY")
        .toUpperCase(),
      currentMonthMoins6: moment(moment(), "MM-YYYY")
        .subtract(6, "months")
        .format("MMMM YY")
        .toUpperCase(),
      displayExport: false,
      evolutionStock: {},
      valuePiquet: [],
      valueBrut: [],
      isGraphFailed: true,
      searchQuery: "",
      filterChangedListener: null,
      filterChangeCounter: 0, // Pour forcer la réactivité du computed hasActiveFilters

      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: false,
        resizable: true,
        suppressMenu: true,
      },
      columnDefs: [
        {
          headerName: "#Internal ID",
          valueGetter: function (params) {
            return "#" + params.data.idproduct;
          },
          filter: true,
          //sort: 'DESC',
          width: 100,
          cellRendererFramework: "CellRendererLink",
          sortable: false,
        },
        {
          field: "category",
          headerName: "Product Category",
          valueGetter: function (params) {
            return "#" + params.data.idcategory + ". " + params.data.category;
          },
          filter: true,
          width: 315,
          sortable: false,
        },
        {
          field: "prod",
          headerName: "Product",
          valueGetter: function (params) {
            return params.data.product;
          },
          filter: true,
          width: 315,
          cellRendererFramework: "CellRendererLink",
          sortable: false,
        },
        {
          headerName: "Stock (UoM)",
          valueGetter: function (params) {
            return params.data.stock_uom;
          },
          //field: 'iscompany',
          filter: false,
          width: 160,
          type: "numericColumn",
          sortable: false,
        },
        {
          headerName: "Projected (UoM)",
          valueGetter: function (params) {
            if (params.data.stock_after_quotation)
              return params.data.stock_after_quotation;
            else return 0;
          },
          //field: 'iscompany',
          filter: false,
          width: 170,
          type: "numericColumn",
          sortable: false,
        },
        {
          headerName: "UoM",
          valueGetter: function (params) {
            return params.data.uom;
          },
          //field: 'iscompany',
          filter: false,
          width: 100,
          sortable: false,
        },
        {
          headerName: "Stock (m3)",
          valueGetter: function (params) {
            if (params.data.stock_volume) return params.data.stock_volume;
            else return " ";
          },
          //field: 'iscompany',
          filter: false,
          width: 160,
          type: "numericColumn",
          sortable: false,
        },
        {
          headerName: "Projected (m3)",
          valueGetter: function (params) {
            if (params.data.stock_after_quotation_volume)
              return params.data.stock_after_quotation_volume;
            else return "-";
          },
          //field: 'iscompany',
          filter: false,
          width: 160,
          type: "numericColumn",
          cellRendererFramework: "CellRendererStatus",
          sortable: false,
        },
        /*{
          headerName: "Popularity",
          field: "popularity",
          valueGetter: function (params) {
            if (params.data.popularity) return params.data.popularity;
            else return 0;
          },
          width: 130,
          sortable: false,
          cellRendererFramework: "CellRendererPopularity",
        },*/
      ],

      // Cell Renderer Components
      components: {
        CellRendererLink,
        CellRendererStatus,
        //CellRendererPopularity,
        CellRendererVerified,
        CellRendererActions,
      },
    };
  },
  computed: {
    categoryDataWithValuations() {
      return this.categoryData.map(c => {
        const found = this.valuationList.find(v =>
          v.idcategory == c.id &&
          (
            (c.idcategory == 29 && v.idproduct == c.idproduct) ||
            (c.idcategory != 29 && v.idproduct == null)
          )
        );
        return {
          ...c,
          valuation_value: found ? found.valuation_value : null
        };
      });
    },
    operationsData() {
      if (!this.$store.state.stockList) {
        return [];
      }
      return this.$store.state.stockList.stocks || [];
    },
    categoryData() {
      return this.$store.state.stockList.stock_category;
    }, 
    categoryTotals() {
      if (!this.categoryDataWithValuations) return {
        gsp6: 0,
        gsp5: 0,
        gsp4: 0,
        gsp3: 0,
        gsp2: 0,
        gsp1: 0,
        gsp0: 0,
        totalValuation: 0,
      };

      return this.categoryDataWithValuations.reduce((totals, item) => {
        totals.gsp6 += parseFloat(item.gsp6 || 0);
        totals.gsp5 += parseFloat(item.gsp5 || 0);
        totals.gsp4 += parseFloat(item.gsp4 || 0);
        totals.gsp3 += parseFloat(item.gsp3 || 0);
        totals.gsp2 += parseFloat(item.gsp2 || 0);
        totals.gsp1 += parseFloat(item.gsp1 || 0);
        totals.gsp0 += parseFloat(item.gsp0 || 0);
        const val = parseFloat(item.valuation);
        const gsp0 = parseFloat(item.gsp0);
        if (!isNaN(val) && !isNaN(gsp0)) {
          totals.totalValuation += val * gsp0;
        }
        return totals;
      }, {
        gsp6: 0,
        gsp5: 0,
        gsp4: 0,
        gsp3: 0,
        gsp2: 0,
        gsp1: 0,
        gsp0: 0,
        totalValuation: 0,
      });
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 30;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
    hasActiveFilters() {
      // Utiliser filterChangeCounter pour forcer la réactivité
      const _ = this.filterChangeCounter;
      if (!this.gridApi) return false;
      const filterModel = this.gridApi.getFilterModel();
      const hasColumnFilters = filterModel && Object.keys(filterModel).length > 0;
      const hasSearchFilter = this.searchQuery && this.searchQuery.trim() !== '';
      return hasColumnFilters || hasSearchFilter;
    },
  },
  methods: {
    async fetchValuations() {
      const res = await axios.get("/valuation");
      this.valuationList = res.data;
    },
    async saveOneValuation(item) {
  const payload = {
    idcategory: item.id,
    value: item.valuation_value === '' ? null : item.valuation_value
  };

  if (item.id === "29") {
    payload.idproduct = item.idid;
  }

  await axios.post("/valuation/update", payload);

  await this.fetchValuations();
  await this.$store.dispatch("stockList/fetchStocksVolume");
  await this.$store.dispatch("stockList/fetchStockByCategory");

  this.$vs.notify({ color: 'success', text: 'Saved!' });
},
    async openValuationModal() {
      await this.fetchValuations();
      this.categoryDataWithEditableValuations = this.categoryData.map(c => {
        const cid = Number(c.id);
        const cidprod = c.idid != null ? Number(c.idid) : null;
        const found = this.valuationList.find(v =>
          Number(v.id) === cid &&
          (
            (cid === 29 && Number(v.idid) === cidprod) ||
            (cid !== 29 && Number(v.idid) === cid)
          )
        );
        return {
          ...c,
          valuation_value: found ? found.valuation_value : null
        };
      });
      this.showValuationModal = true;
    },
    refreshMat() {
      this.$vs.notify({
        color: "success",
        title: "Refreshing...",
        iconPack: "feather",
        icon: "icon-download-cloud",
        text: "Please wait while we refresh the content...",
        time: 4000,
      });
      this.$store
        .dispatch("stockList/fetchRefreshStocks")
        .then((response) => {
          this.$vs.notify({
            color: "success",
            title: "Refresh OK",
            iconPack: "feather",
            icon: "icon-download-cloud",
            text: "Refresh success",
            time: 1000,
          });
        })
        .catch((err) => {
          console.error(err);
        });
    },
    onCellContextMenu(event) {
      this.currentValue = event.value; // Stocker la valeur actuelle pour les actions

      if (event.column.colId === 'category') {
        const contextMenu = document.getElementById('contextMenu');
        let posX = event.event.clientX;
        const posY = event.event.clientY;

        contextMenu.style.display = 'block';
        contextMenu.style.left = `${posX - 265}px`;
        contextMenu.style.top = `${posY}px`;
      }
      else if (event.column.colId === 'prod') {
        const contextMenuProd = document.getElementById('contextMenuProd');
        let posX = event.event.clientX;
        const posY = event.event.clientY;

        contextMenuProd.style.display = 'block';
        contextMenuProd.style.left = `${posX - 265}px`;
        contextMenuProd.style.top = `${posY}px`;
      }
      // un peu décal a cause du menu de gauche.
    },
    filterByValue(currentVal = null) {

      if (currentVal !== 'NOTFROMBOTTOM') {
        var filterModel = {
          category: { // Assurez-vous que cela correspond à l'identifiant de la colonne (colId) si différent du nom du champ (field)
            type: 'contains', // Type de condition (equals, notEqual, contains, etc.)
            filter: currentVal, // La valeur que vous souhaitez appliquer au filtre
          }
        };
        this.gridOptions.api.setFilterModel(filterModel); // Appliquez le modèle de filtre à la grille
        window.scrollTo(0, 0);

      }
      else {
        var filterModel = {
          category: { // Assurez-vous que cela correspond à l'identifiant de la colonne (colId) si différent du nom du champ (field)
            type: 'contains', // Type de condition (equals, notEqual, contains, etc.)
            filter: this.currentValue, // La valeur que vous souhaitez appliquer au filtre
          }
        };
        this.gridOptions.api.setFilterModel(filterModel); // Appliquez le modèle de filtre à la grille
      }
      this.hideContextMenu();
    },
    filterByValueProd(currentVal = null) {
      var filterModel = {
        prod: { // Assurez-vous que cela correspond à l'identifiant de la colonne (colId) si différent du nom du champ (field)
          type: 'contains', // Type de condition (equals, notEqual, contains, etc.)
          filter: this.currentValue, // La valeur que vous souhaitez appliquer au filtre
        }
      };
      this.gridOptions.api.setFilterModel(filterModel); // Appliquez le modèle de filtre à la grille

      this.hideContextMenu();
    },
    filterClear() {
      var filterModel = {
        category: { // Assurez-vous que cela correspond à l'identifiant de la colonne (colId) si différent du nom du champ (field)
          type: 'contains', // Type de condition (equals, notEqual, contains, etc.)
          filter: '', // La valeur que vous souhaitez appliquer au filtre
        }
      };
      this.gridOptions.api.setFilterModel(filterModel); // Appliquez le modèle de filtre à la grille

      this.hideContextMenu();
    },
    filterClearProd() {
      var filterModel = {
        prod: { // Assurez-vous que cela correspond à l'identifiant de la colonne (colId) si différent du nom du champ (field)
          type: 'contains', // Type de condition (equals, notEqual, contains, etc.)
          filter: '', // La valeur que vous souhaitez appliquer au filtre
        }
      };
      this.gridOptions.api.setFilterModel(filterModel); // Appliquez le modèle de filtre à la grille

      this.hideContextMenu();
    },
    copyValue() {
      console.log('Copying value:', this.currentValue);
      navigator.clipboard.writeText(this.currentValue).then(() => {
        console.log('Value copied to clipboard');
      }, (err) => {
        console.error('Error copying text: ', err);
      });
      this.hideContextMenu();
    },
    hideContextMenu() {
      const contextMenu = document.getElementById('contextMenu');
      const contextMenuProd = document.getElementById('contextMenuProd');
      contextMenu.style.display = 'none';
      contextMenuProd.style.display = 'none';
    },
    sizetofit() {
      if (this.gridApi) {
        if (this.gridApi.paginationGetTotalPages()) {
          if (this.alreadyajusted == false) {
            //this.gridApi.sizeColumnsToFit();
            this.alreadyajusted = true;
          }
        }
      }
    },
    copyToClipboard(containerid) {
      var range = document.createRange();
      let containerNode = document.getElementById(containerid); //// this part
      range.selectNode(containerNode); //// this part
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand("copy");
      window.getSelection().removeAllRanges();
      this.$vs.notify({
        color: "success",
        text:
          "Data copied to Clipboard!"
      });
    },
    removeFilter() {
      this.filterClear()
    },
    getProductSortedByProjectedVolume() {
      //this.$vs.loading();
      this.$store
        .dispatch("stockList/fetchStocksVolume")
        .then((response) => {
          //this.$vs.loading.close();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getProductSortedByName() {
      //this.$vs.loading();
      this.$store
        .dispatch("stockList/fetchStocksv3")
        .then((response) => {
          //this.$vs.loading.close();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column);
      let modelObj = null;

      if (val !== "all") {
        modelObj = { type: "equals", filter: val };
      }

      filter.setModel(modelObj);
      this.gridApi.onFilterChanged();
    },
    resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null);
      this.gridApi.onFilterChanged();

      // Reset Filter Options
      this.roleFilter =
        this.statusFilter =
        this.isVerifiedFilter =
        this.departmentFilter =
        {
          label: "All",
          value: "all",
        };

      this.$refs.filterCard.removeRefreshAnimation();
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
      // Forcer la mise à jour du computed
      this.filterChangeCounter++;
    },
    onGridReady(params) {
      this.gridApi = params.api;
      
      // Écouter les changements de filtres
      this.filterChangedListener = () => {
        // Incrémenter le compteur pour forcer la réactivité du computed hasActiveFilters
        this.filterChangeCounter++;
      };
      this.gridApi.addEventListener('filterChanged', this.filterChangedListener);
    },
    clearAllFilters() {
      // Réinitialiser tous les filtres
      if (this.gridApi) {
        this.gridApi.setFilterModel(null);
        this.gridApi.setQuickFilter('');
        this.searchQuery = '';
        this.gridApi.onFilterChanged();
        // Forcer la mise à jour du computed
        this.filterChangeCounter++;
      }
    },
  },
  mounted() {
    document.addEventListener('click', (event) => {
      if (!event.target.closest('#contextMenu')) {
        this.hideContextMenu();
      }
    });

    this.$nextTick(() => {
      const gridEl = this.$refs.agGridTable.$el;
      gridEl.addEventListener('contextmenu', (event) => {
        event.preventDefault();
      });
    });
  },
  beforeRouteLeave(to, from, next) {
    const isViewPage = to.params && (to.params.userId || to.params.id || to.params.productid);
    const isEditPage = to.path && (to.path.includes('-edit/') || to.path.includes('-view/') || to.path.includes('View') || to.path.includes('/stock/'));
    
    if (!isViewPage && !isEditPage) {
      // Clear filters if not going to a view page
    }
    next();
  },
  beforeDestroy() {
    if (this.gridApi && this.filterChangedListener) {
      this.gridApi.removeEventListener('filterChanged', this.filterChangedListener);
    }
  },
  created() {
    //this.$vs.loading();
    if (localStorage.getItem("login-roles").toLowerCase().includes("admin")) {
      this.displayExport = true;
    }
    if (!moduleStockList.isRegistered) {
      this.$store.registerModule("stockList", moduleStockList);
      moduleStockList.isRegistered = true;
    }
    this.$store
      .dispatch("stockList/fetchStocksVolume")
      .then((response) => {
        this.$store
          .dispatch("stockList/fetchStockByCategory")
          .then((response) => {
          })
          .catch((err) => {
            console.error(err);
          });
      })
      .catch((err) => {
        console.error(err);
      });
  },
};
</script>
<style lang="scss" scpoped>
.context-menu {
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.context-menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.context-menu ul li {
  padding: 10px;
  cursor: pointer;
}

.context-menu ul li:hover {
  background-color: #f0f0f0;
}
</style>
